module.exports = __webpack_public_path__ + "img/hr-level2addon_running.48069b29.png";